"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = exports.generatePlatform = void 0;
function base64URLEncode(input) {
    return btoa(String.fromCharCode(...input))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}
function browserCrypto() {
    var _a;
    return {
        getRandomValues: crypto.getRandomValues.bind(crypto),
        subtle: (_a = crypto.webkitSubtle) !== null && _a !== void 0 ? _a : crypto.subtle
    };
}
function generatePlatform(crypto) {
    return __awaiter(this, void 0, void 0, function* () {
        const encoder = new TextEncoder();
        const bytes = crypto.getRandomValues(new Uint8Array(32));
        if (bytes === null || bytes.byteLength === 0)
            throw new Error('crypto.getRandomValues returned null/no bytes');
        const code_verifier = base64URLEncode(bytes);
        const code_challenge_method = 'S256';
        const buffer = yield crypto.subtle.digest('SHA-256', encoder.encode(code_verifier));
        const code_challenge = base64URLEncode(new Uint8Array(buffer));
        if (!(code_verifier === null || code_verifier === void 0 ? void 0 : code_verifier.length))
            throw new Error('Unable to generate PKCE, code_verifier blank');
        if (!(code_challenge === null || code_challenge === void 0 ? void 0 : code_challenge.length))
            throw new Error('Unable to generate PKCE, code_challenge blank');
        return { code_verifier, code_challenge, code_challenge_method };
    });
}
exports.generatePlatform = generatePlatform;
function generate() {
    const crypto = browserCrypto();
    return generatePlatform(crypto);
}
exports.generate = generate;
//# sourceMappingURL=pkce.js.map